import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Button, ChevronIcon } from '../../common';

import './SmsConfirmation.scoped.scss';

interface Props {
  header: ReactNode;
  onClose: () => void;
}

const SmsConfirmation: FC<PropsWithChildren<Props>> = ({ header, onClose, children }) => {
  return (
    <div className="sms-confirmation">
      <Button onClick={onClose} className="sms-confirmation__button">
        <ChevronIcon direction="left" color="var(--primary-green-new)" title="Закрыть" />
      </Button>
      <header className="sms-confirmation__header">{header}</header>
      {children}
    </div>
  );
};

export default SmsConfirmation;
